import * as React from 'react'
import { BLUE } from '../../colors'

const IconEdit = (props) => {
  const { width, height, color, ...rest } = props

  return (
    <svg width={width || 24} height={height || 24} xmlns='http://www.w3.org/2000/svg' {...rest} viewBox='0 0 24 24'>
      <path
        d='M21.471 7.229 7.87 20.83 2 21.471l.641-5.871L16.242 2z'
        stroke={color || BLUE}
        strokeWidth={3}
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconEdit
